import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Stack } from "components/layout/reusableLayouts";

export interface HomeApp {
  url: string;
  name: string;
}

interface WrongAppDialogProps {
  open: boolean;
  homeApp: HomeApp;
  onLogout: () => void;
}

/**
 * Offered to someone whose account belongs to another platform: go there, or
 * log out. There is no dismissal, since neither leaving it open nor closing it
 * gets them anywhere they are allowed to be.
 */
export default function WrongAppDialog({
  open,
  homeApp,
  onLogout,
}: WrongAppDialogProps) {
  const { t } = useTranslation();
  const appName = homeApp.name;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>{t("Account validation")}</DialogTitle>
      <DialogContent>
        <Stack gap="var(--space-3)">
          <Typography
            variant="body2"
            sx={{ color: "var(--color-text-secondary)" }}
          >
            {t(
              "You are logged into an account that is registered on another platform",
            )}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "var(--color-text-secondary)" }}
          >
            {t(
              "Would you like to navigate there or log out so you can access this platform?",
            )}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="default-outlined" onClick={onLogout}>
          {t("Log out")}
        </Button>
        <Button variant="primary-filled" href={homeApp.url}>
          {t("Return to {{appName}}", { appName })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
